import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';

@Component({
  selector: 'upsc-custom-toast',
  templateUrl: './custom-toast.component.html',
  styleUrls: ['./custom-toast.component.scss']
})
export class CustomToastComponent {
  constructor(
    public snackBarRef: MatSnackBarRef<CustomToastComponent>,
    @Inject(MAT_SNACK_BAR_DATA) public data: any
  ) { }

  close() {
    this.snackBarRef.dismiss();
  }

}
